import { useCallback } from 'react';
import { STORAGE_KEYS, useLocalStorage } from './useLocalStorage';

export function useFavorites() {
  const [favorites, setFavorites] = useLocalStorage<string[]>(STORAGE_KEYS.favorites, []);

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  const toggleFavorite = useCallback(
    (id: string) => {
      setFavorites((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [id, ...prev]));
    },
    [setFavorites],
  );

  return { favorites, isFavorite, toggleFavorite };
}

export interface HistoryItem {
  id: string;
  watchedAt: string;
}

export function useHistory() {
  const [history, setHistory] = useLocalStorage<HistoryItem[]>(STORAGE_KEYS.history, []);

  const pushHistory = useCallback(
    (id: string) => {
      setHistory((prev) => {
        const next = prev.filter((item) => item.id !== id);
        next.unshift({ id, watchedAt: new Date().toISOString() });
        return next.slice(0, 12);
      });
    },
    [setHistory],
  );

  const clearHistory = useCallback(() => setHistory([]), [setHistory]);

  return { history, pushHistory, clearHistory };
}